import React from 'react';
import { view } from 'react-easy-state';
import Store from '../store/store';


const PrestDelBtn = ({ idx, onClick }) => {
  const { showDelBtn } = Store;

  return (
    <div className="kf-pren-btn-mod">
      {
        showDelBtn(idx) && 
        <div role="button" className="kfpr-top-link kfpr-link kfpr-link-red" onClick={onClick}>
          elimina
        </div>
      }
    </div>
  )
}

export default view(PrestDelBtn);